import { Component } from "@angular/core";
import { IonicPage, NavController, Menu, App, LoadingController, Loading, Platform } from "ionic-angular";
import { SecurityConfiguration } from "../../security/security.configuration";
import { HomeService } from "./home.service";
import { trigger, style, transition, animate, keyframes, query, stagger } from "@angular/animations";
import { TranslateService, } from "@ngx-translate/core";
import { AssetLandingPage } from '../asset-landing/asset-landing';
import { AssetService } from "../../services/asset.service";
import { ProjectService } from "../../services/project.service";
import { Storage } from "@ionic/storage";
import { LoginPage } from "../login/login";
import { AlertController } from 'ionic-angular';
import * as _ from 'lodash';
import { OAuthService } from 'angular-oauth2-oidc';

declare let ga: any;

@IonicPage()
@Component({
  selector: 'page-home',
  templateUrl: 'home.html',
  animations: [
    trigger('ngIfAnimation', [
      transition('void => *', [
        query('*', stagger('0ms', [
          animate('0.1s ease-in', keyframes([
            style({ opacity: 0, transform: 'translateX(-75%)', offset: 0 }),
            style({ opacity: .5, transform: 'translateX(5px)', offset: 0.3 }),
            style({ opacity: 1, transform: 'translateX(0)', offset: 1.0 }),
          ]))]), { optional: true }),
      ]),
      transition('* => void', [
        query('*', stagger('0ms', [
          animate('0.1s ease-in', keyframes([
            style({ opacity: 1, transform: 'translateX(0)', offset: 0 }),
            style({ opacity: .5, transform: 'translateX(5px)', offset: 0.3 }),
            style({ opacity: 0, transform: 'translateX(-75%)', offset: 1.0 }),
          ]))]), { optional: true }),
      ])
    ])
  ],
  providers: [TranslateService]
})
export class HomePage {

  public isActive: boolean = false;
  public username: string;
  public userDetails: any;
  public treeStructureData: any;
  public maindata: any = [];
  public searchData: any = [];
  public pushedData: any = [];
  public favouriteTreeStructuredData: any;
  public isSlideMenuOpened: boolean = false;
  public customerList: any = [];
  public branchDetails: any = [];
  public categories: string = "favourites";
  public queryString: string = "";
  public favouriteCustomerIds: any = [];
  public fetchDataSpinner: Loading;
  public access_token: string;
  public cfaUser: boolean;
  public areSitesMapped: boolean;
  public currPlatform: any;
  public menuType: string = "home";
  public checkLicence: boolean;
  private filteredArray = [];
  private currentCustomer: any = {};
  public languageArray: any;
  public lan: any;
  public Language: any;
  public lanarray: any;
  public dblang: any ;
  private originalFavouriteTreeStructuredData: any = [];
  public isNewChrome: boolean = false;

  public spinnerOptions = {
    content: this.translate.instant('Fetchingdata'),
    spinner: 'bubbles'
  }

  public spinnerOptionsSave = {
    content: this.translate.instant('SavingData'),
    spinner: 'bubbles'
  }

  private actualTree: any = [];
  private cfaOriginialData: any = [];

  constructor(
    private platform: Platform,
    public navCtrl: NavController,
    private loadingCtrl: LoadingController,
    private storage: Storage,
    public securityConfig: SecurityConfiguration,
    public homeService: HomeService,
    private translateService: TranslateService,
    private assetService: AssetService,
    private projectService: ProjectService,
    private alertCtrl: AlertController,
    public translate: TranslateService,
    private oauthService:OAuthService
  ) { }

  ngOnInit(){
    if (this.oauthService.hasValidIdToken()) {
      this.ngOnInit1();
    }
    else
    {
      setTimeout(() => {
        this.ngOnInit1();
      }, 10000);
    }
  }

  ngOnInit1() {
    // this.lan = sessionStorage.setItem("lang", "en")
    // this.getLanguage();
    let userAgent = navigator.userAgent.toLowerCase();
    //Add margin top if the platform is android and chrome's version is greater than 70. Need to be tested more on different chrome versions between 65 and 70.
    userAgent.indexOf('android') >= 0 && Number(userAgent.split('chrome/')[1][0]) > 6 ? this.isNewChrome = true : this.isNewChrome = false;
    this.fetchDataSpinner = this.loadingCtrl.create(this.spinnerOptions);
    this.fetchDataSpinner.present();
    if (this.platform.is('ios')) {
      this.currPlatform = "ios";
    }
    else if (this.platform.is('android')) {
      this.currPlatform = "android";
    }
    if (this.queryString == "") {
      this.searchData = JSON.parse(JSON.stringify(this.maindata));
    }

    if (this.platform.is("mobileweb") || this.platform.is("core")) {
      this.username = JSON.parse(sessionStorage.getItem('id_token_claims_obj')).globalid;
      this.username = this.username.replace("~AAD:", "");
      this.access_token = sessionStorage.getItem('access_token');
      this.getDataSourceForUser();
      ga('set', 'title', 'Favorites');
      ga('set', 'page', '/mobile/dashboard/favourites');
      ga('set', 'dimension1', this.username);
      ga('send', 'pageview');
    //  this.getLanguage();
    }
    else {
      this.storage.get('username').then((username) => {
        this.username = username;
        this.storage.get('access_token').then((token) => {
          this.access_token = token;
          this.getDataSourceForUser();
        })
      })
    }
    // this.getLanguage();

  }

  getDataSourceForUser() {
    this.homeService.getDataSourceForUser(this.access_token)
      .subscribe((data) => {
        window.sessionStorage.setItem('isNetCoreUser', JSON.stringify(data));
        this.fetchUserDetails();
  }, (error) => {
        this.fetchUserDetails();
        this.fetchDataSpinner.dismiss();
  });
  }

  getLanguage() {
    this.homeService.GetLangauges(this.access_token).subscribe(data => {
      this.languageArray = data;
      this.lanarray = JSON.parse(sessionStorage.getItem("lanarray"))
      if (this.lanarray && this.lanarray.id) {
        var newarray = this.languageArray.find(x => x.id === this.lanarray.id);
        this.Language = newarray;
      }
      else{
        var newarray = this.languageArray.find(x => x.Language === this.dblang);
        this.Language = newarray;
        this.onChange(this.Language);
      }

    })
  }
  onChange(e) {
    if (e.Language == "English") {
      this.translate.use("en")
      this.translate.setDefaultLang("en")
      this.lan = sessionStorage.setItem("lang", "en")
      this.lanarray = sessionStorage.setItem("lanarray", JSON.stringify(e))
    }
    else if(e.Language == "Chinese"){
      this.translate.use("zh-Hans")
      this.translate.setDefaultLang("zh-Hans")
      this.lan = sessionStorage.setItem("lang", "zh-Hans")
      this.lanarray = sessionStorage.setItem("lanarray", JSON.stringify(e))
    }
    else if(e.Language == "Portuguese")
    {
      this.translate.use("pt")
      this.translate.setDefaultLang("pt")
      this.lan = sessionStorage.setItem("lang", "pt")
      this.lanarray = sessionStorage.setItem("lanarray", JSON.stringify(e))
    }
    else if(e.Language == "Italian")
    {
      this.translate.use("it-IT")
      this.translate.setDefaultLang("it-IT")
      this.lan = sessionStorage.setItem("lang", "it-IT")
      this.lanarray = sessionStorage.setItem("lanarray", JSON.stringify(e))
    }
    else if(e.Language == "Hungarian")
    {
      this.translate.use("hu-Hu")
      this.translate.setDefaultLang("hu-Hu")
      this.lan = sessionStorage.setItem("lang", "hu-Hu")
      this.lanarray = sessionStorage.setItem("lanarray", JSON.stringify(e))
    }
    else if(e.Language == "Norwegian")
    {
      this.translate.use("nb-NO")
      this.translate.setDefaultLang("nb-NO")
      this.lan = sessionStorage.setItem("lang", "nb-NO")
      this.lanarray = sessionStorage.setItem("lanarray", JSON.stringify(e))
    }
    else if(e.Language == "Russian")
    {
      this.translate.use("ru-RU")
      this.translate.setDefaultLang("ru-RU")
      this.lan = sessionStorage.setItem("lang", "ru-RU")
      this.lanarray = sessionStorage.setItem("lanarray", JSON.stringify(e))
    }
    else if(e.Language == "Czech")
    {
      this.translate.use("cs-CZ")
      this.translate.setDefaultLang("cs-CZ")
      this.lan = sessionStorage.setItem("lang", "cs-CZ")
      this.lanarray = sessionStorage.setItem("lanarray", JSON.stringify(e))
    }
    else if(e.Language == "Polish")
    {
      this.translate.use("pl-PL")
      this.translate.setDefaultLang("pl-PL")
      this.lan = sessionStorage.setItem("lang", "pl-PL")
      this.lanarray = sessionStorage.setItem("lanarray", JSON.stringify(e))
    }
    else if(e.Language == "French")
    {
      this.translate.use("fr-FR")
      this.translate.setDefaultLang("fr-FR")
      this.lan = sessionStorage.setItem("lang", "fr-FR")
      this.lanarray = sessionStorage.setItem("lanarray", JSON.stringify(e))
    } 
    else if(e.Language == "Turkish")
    {
      this.translate.use("tr-TR")
      this.translate.setDefaultLang("tr-TR")
      this.lan = sessionStorage.setItem("lang", "tr-TR")
      this.lanarray = sessionStorage.setItem("lanarray", JSON.stringify(e))
    }
    else{
      this.translate.use("es")
      this.translate.setDefaultLang("es")
      this.lan = sessionStorage.setItem("lang", "es")
      this.lanarray = sessionStorage.setItem("lanarray", JSON.stringify(e))
    }


  }
  fetchUserDetails() {
    this.homeService.getUserDetails(this.access_token, this.username)
      .subscribe((userDetails) => {
        if (userDetails && userDetails.length > 0) {
          this.userDetails = userDetails[0];
          this.cfaUser = this.userDetails.IsCFAUser;
          this.lan = sessionStorage.getItem("lang")
          if (this.lan && this.userDetails.LanguageName.toLowerCase() == sessionStorage.getItem("lang")) {
            this.translate.use(this.lan)
            this.translate.setDefaultLang(this.lan)
          }
          else {
            this.translate.use(this.userDetails.LanguageName.toLowerCase())
            this.translate.setDefaultLang(this.userDetails.LanguageName.toLowerCase())
            sessionStorage.setItem("lang", this.userDetails.LanguageName.toLowerCase());
            if (this.userDetails.LanguageName.toLowerCase() == "en") {
              this.dblang = "English";
            }
            else if (this.userDetails.LanguageName.toLowerCase() =="zh-Hans"){
              sessionStorage.setItem("lang", "cn");
              this.dblang = "Chinese";
            }
            else if (this.userDetails.LanguageName.toLowerCase() =="it-IT"){
              sessionStorage.setItem("lang", "it");
              this.dblang = "Italian";
            }
            else if (this.userDetails.LanguageName.toLowerCase() =="hu-Hu" || this.userDetails.LanguageName.toLowerCase() =="hu"){
              sessionStorage.setItem("lang", "hu");
              this.dblang = "Hungarian";
            }
            else if (this.userDetails.LanguageName.toLowerCase() =="nb-NO" || this.userDetails.LanguageName.toLowerCase() =="nb"){
              sessionStorage.setItem("lang", "nb");
              this.dblang = "Norwegian";
            }
            else if (this.userDetails.LanguageName.toLowerCase() =="ru-RU" || this.userDetails.LanguageName.toLowerCase() =="ru"){
              sessionStorage.setItem("lang", "ru");
              this.dblang = "Russian";
            }
            else if (this.userDetails.LanguageName.toLowerCase() =="cs-CZ" || this.userDetails.LanguageName.toLowerCase() =="cs"){
              sessionStorage.setItem("lang", "cs");
              this.dblang = "Czech";
            }
            else if (this.userDetails.LanguageName.toLowerCase() =="fr-FR" || this.userDetails.LanguageName.toLowerCase() =="fr"){
              sessionStorage.setItem("lang", "fr");
              this.dblang = "French";
            }
            else if (this.userDetails.LanguageName.toLowerCase() =="pl-PL" || this.userDetails.LanguageName.toLowerCase() =="pl"){
              sessionStorage.setItem("lang", "pl");
              this.dblang = "Polish";
            }
            else if (this.userDetails.LanguageName.toLowerCase() =="es-ES" || this.userDetails.LanguageName.toLowerCase() =="es"){
              sessionStorage.setItem("lang", "es");
              this.dblang = "Spanish";
            }
            else if (this.userDetails.LanguageName.toLowerCase() =="tr-TR" || this.userDetails.LanguageName.toLowerCase() =="tr"){
              sessionStorage.setItem("lang", "tr");
              this.dblang = "Turkish";
            }
            else{
              this.dblang = "English";
            }
          }
          if (this.platform.is("mobileweb") || this.platform.is("core")) {
            window.sessionStorage.setItem('userId', this.userDetails.UserId);
            window.sessionStorage.setItem('cfaUser', String(this.cfaUser));
            if (this.cfaUser) {
              this.getBranchDetails();
            }
          }
          else {
            this.storage.set('userId', this.userDetails.UserId);
            this.storage.set('cfaUser', this.cfaUser);
          }
          this.getCheckDetails();
          this.getTreeStructureData();
        }
        else {
          this.fetchDataSpinner.dismiss();
        }
      }, (error) => this.fetchDataSpinner.dismiss());
  }

  changeCategories() {
    this.categories == "favourites" ? "customers" : "favourites";
    setTimeout(() => {
      if (this.categories == 'customers') {
        let div = document.getElementById('customerListDiv');
        div.onscroll = (e: any) => {
          if (e.target.scrollHeight - (e.target.scrollTop + e.target.clientHeight) < 10) {
            if (this.actualTree.length != this.filteredArray.length) {
              if (this.actualTree.length > (this.filteredArray.length - 30)) {
                this.actualTree = this.filteredArray.slice(0, this.actualTree.length + (this.filteredArray.length - this.actualTree.length));
              }
              else {
                this.actualTree = this.filteredArray.slice(0, this.actualTree.length + 30);
              }
            }
          }
        }
      }
    }, 400)

    if (this.categories == "customers") {
      ga('set', 'title', 'Overview');
      ga('set', 'page', '/mobile/dashboard/' + this.categories);
      ga('set', 'dimension1', this.username);
      ga('send', 'pageview');
    }
    else {
      {
        ga('set', 'title', 'Favorites');
        ga('set', 'page', '/mobile/dashboard/' + this.categories);
        ga('set', 'dimension1', this.username);
        ga('send', 'pageview');
      }
    }

  }

  toggleMenu() {
    this.isSlideMenuOpened = !this.isSlideMenuOpened;
  }
  selectMenu($event) {
    this.menuType = $event;
    this.isSlideMenuOpened = false;
  }
  logout() {
    if (this.platform.is("mobileweb") || this.platform.is("core")) {
      this.securityConfig.logout();
    }
    else {
      this.storage.clear().then((clear) => {
        this.homeService.resetCustomerList();
        this.navCtrl.setRoot(LoginPage);
      })
    }
  }

  getBranchDetails() {
    this.homeService.getBranchDetails(this.access_token, this.username).subscribe(res => {
      this.branchDetails = res;
    }, (error) => {
    })
  }

  downloadHelpDocument() {
    let xhr = new XMLHttpRequest();
    xhr.open("GET", "assets/imgs/helpdoc.pdf");
    xhr.responseType = "blob";
    xhr.onload = function () {
      let file = new Blob([xhr.response], {
        type: 'application/pdf'
      });
      let url = URL.createObjectURL(file);
      let a = document.createElement('a');
      a.href = url, a.download = "CEP_Mobile_User_Guid.pdf";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    };

    xhr.send(null);
  }

  expandCustomer(e, customer) {
    if (e.target.tagName.toLowerCase() == 'ion-icon') {
      return;
    }
    customer.open = !customer.open;
  }

  addToFavourites(customer, value) {
    this.homeService.saveCustomersToFavourite(this.access_token, {
      UserId: this.userDetails.UserId,
      CustomerId: customer.id,
      isRemoved: value
    })
      .subscribe((data) => {
        if (data) {
          if (value) {
            //REMOVE FAVOURITE
            this.fetchDataSpinner = this.loadingCtrl.create({
              content: 'Removing from favourites...',
              spinner: "bubbles"
            });
            this.fetchDataSpinner.present();
            //this.finalfavouriteTree=JSON.parse(JSON.stringify(this.favouriteTreeStructuredData));
            this.favouriteTreeStructuredData = this.favouriteTreeStructuredData.filter((el) => el.id !== customer.id);
            this.favouriteCustomerIds = this.favouriteCustomerIds.filter((el) => el !== customer.id);

            this.fetchDataSpinner.dismiss();
          } else {
            //ADD FAVOURITE
            this.fetchDataSpinner = this.loadingCtrl.create({
              content: 'Adding to favourites...',
              spinner: "bubbles"
            });
            this.fetchDataSpinner.present();
            let currCustomer = this.customerList.find((el) => el.id == customer.id);
            if (currCustomer) {
              this.favouriteCustomerIds.push(customer.id);
              this.favouriteTreeStructuredData.push(JSON.parse(JSON.stringify(currCustomer)));
              this.favouriteTreeStructuredData = _.uniqBy(this.favouriteTreeStructuredData, 'id');
              this.fetchDataSpinner.dismiss();


            }
          }
        }
      }, (error) => this.fetchDataSpinner.dismiss());
  }

  getFavouriteCustomers() {
    this.homeService.getFavouriteCustomers(this.access_token, this.userDetails.UserId)
      .subscribe((data) => {
        this.favouriteTreeStructuredData = this.homeService.filterFavourites(data[0], JSON.parse(JSON.stringify(this.customerList)));
        this.originalFavouriteTreeStructuredData = JSON.parse(JSON.stringify(this.favouriteTreeStructuredData));
        this.favouriteCustomerIds = this.favouriteTreeStructuredData.map((el) => el.id);
        this.fetchDataSpinner.dismiss();
      }, (error) => this.fetchDataSpinner.dismiss());
  }

  getCheckDetails() {
    this.homeService.GetAgreementCheckDetails(this.access_token, this.username)
      .subscribe(data => {
        this.checkLicence = data.isChecked;
        if (this.checkLicence == false && this.cfaUser == true) {
          this.checkUserLicence();
        }
      }, (error) => {
      })
  }

  getTreeStructureData() {
    this.homeService.getTreeStructureData(this.access_token, this.username)
      .subscribe((data) => {
        this.treeStructureData = data;
        this.maindata = this.treeStructureData;
        //this.searchData=this.treeStructureData;
        this.homeService.resetCustomerList();
        this.customerList = this.homeService.getCustomersFromTreeStructure(this.treeStructureData, 'customer').sort((a, b) => a.name.localeCompare(b.name));
        if (this.queryString == "") {
          this.searchData = this.customerList;
          this.cfaOriginialData = JSON.parse(JSON.stringify(this.customerList));
          this.filteredArray = JSON.parse(JSON.stringify(this.searchData))
          if (this.filteredArray.length > 30) {
            this.actualTree = this.filteredArray.slice(0, 30)
          }
          else {
            this.actualTree = this.filteredArray;
          }
        }
        this.areSitesMapped = this.homeService.areSitesMapped(this.customerList);
        if (!this.cfaUser) {
          this.getFavouriteCustomers();
        }
        else {
          this.fetchDataSpinner.dismiss();
        }
      }, (error) => this.fetchDataSpinner.dismiss());
  }

  getColorCodeForCustomer(customer) {
    return this.homeService.getColorCodeForCustomer(customer);
  }

  getColorCodeForProject(project) {
    return this.homeService.getColorCodeForProject(project);
  }

  getColorCodeForAsset(asset) {
    return this.homeService.getColorCodeForAsset(asset);
  }

  pushAssetLandingPage(asset: any, project: any) {
    this.projectService.set(project);
    this.assetService.set(asset);
    this.navCtrl.push(AssetLandingPage);
  }

  openCustomerTab() {
    this.categories = "customers";
  }

  doRefresh(refresher) {
    this.fetchDataSpinner = this.loadingCtrl.create({
      content: this.translate.instant('Fetchingdata'),
      spinner: "bubbles"
    });
    this.fetchDataSpinner.present();
    this.getCheckDetails();
    this.fetchUserDetails();
    refresher.complete();
  }

  checkUserLicence() {
    let alert = this.alertCtrl.create({
      subTitle: this.translate.instant('PleaseaccepttheLicenseAgreement'),
      buttons: [
        {
          text: 'OK',
          handler: () => {
            this.logout()
          }
        }

      ],
      enableBackdropDismiss: false
    });
    alert.present();
  }





  initiateSearch() {
    if (this.categories == 'customers') {
      this.filteredArray.length = 0;
      this.actualTree.length = 0;
      //return array.filter((element) => element.name.toLowerCase().indexOf(queryString.toLowerCase()) >= 0)
      if (this.queryString) {
        this.searchRecursively(this.searchData, this.queryString, this.filteredArray);
        let stringifiedArray = this.filteredArray.map((el) => JSON.stringify(el));
        stringifiedArray = stringifiedArray.filter((el, index, self) => self.indexOf(el) == index);
        this.filteredArray = stringifiedArray.map((el) => JSON.parse(el));
      }
      else {
        this.filteredArray = JSON.parse(JSON.stringify(this.searchData));;
      }
      if (this.filteredArray.length > 30) {
        this.actualTree = this.filteredArray.slice(0, 30);
      }
      else {
        this.actualTree = JSON.parse(JSON.stringify(this.filteredArray));
      }
    }
    else {
      this.favouriteTreeStructuredData.length = 0;
      this.searchRecursively(this.originalFavouriteTreeStructuredData, this.queryString, this.favouriteTreeStructuredData);
    }
  }

  searchRecursively(array, queryString, filterArray) {
    array.forEach(el => {
      if (el.type && el.type.toLowerCase() == 'customer') {
        this.currentCustomer = el;
      }
      if (el.type && el.name.toLowerCase().indexOf(queryString.toLowerCase()) >= 0) {
        if (el.type.toLowerCase() == 'customer') {
          this.insertUpdateFilterArray(filterArray, el);
        }
        else {
          this.insertUpdateFilterArray(filterArray, this.currentCustomer);
        }
      }
      else {
        if (el.children && el.children.length > 0) {
          this.searchRecursively(el.children, queryString, filterArray);
        }
      }
    })
  }

  cfaInitiateSearch() {
    this.customerList.length = 0;
    this.customerList = JSON.parse(JSON.stringify(this.cfaOriginialData));
    if (!this.queryString) {
      return;
    }
    let temp = [];
    this.customerList[0].children.forEach(el => {
      if (el.name && el.name.toLowerCase().indexOf(this.queryString) >= 0) {
        this.insertUpdateFilterArray(temp, el);
      }
      else {
        if (el.children && el.children.length > 0) {
          el.children.forEach(childEl => {
            if (childEl.name && childEl.name.toLowerCase().indexOf(this.queryString) >= 0) {
              this.insertUpdateFilterArray(temp, el);
            }
          })
        }
      }
    })
    this.customerList[0].children = temp;
  }

  insertUpdateFilterArray(arr, el) {
    let temp = arr.find(curr => curr.name == el.name)
    if (temp == null) {
      arr.push(el)
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts